export enum AccessibilityContrastEnum {
  NON_IMPAIRED,
  IMPAIRED,
}

export enum AccessibilityDyslexiaEnum {
  NON_DYSLEXIC,
  DYSLEXIC,
}

export enum AccessibilityFontSizeEnum {
  FONT_SIZE_3XS = -4,
  FONT_SIZE_2XS,
  FONT_SIZE_XS,
  FONT_SIZE_S,
  FONT_SIZE_M,
  FONT_SIZE_L,
  FONT_SIZE_XL,
  FONT_SIZE_2XL,
  FONT_SIZE_3XL,
}
